module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/security/components/logout-route.component.scss
// module id = ./src/app/security/components/logout-route.component.scss
// module chunks = main